import { injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable } from 'mobx';

interface ErrorInfo {
    errorLogEntryId: string;
    message: string;
}

@injectable()
export class NotifyDevelopersStore {
    @observable
    errorInfo?: ErrorInfo;

    constructor() {
        makeObservable(this);
    }

    @action
    setErrorInfo = (errorData: ErrorInfo) => {
        this.errorInfo = errorData;
    };
}
